import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already accepted cookies
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        // Save consent to local storage so banner doesn't show again
        localStorage.setItem("cookieConsent", "true");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full bg-darkblue text-white p-4 shadow-lg border-t border-gray-600 z-50 flex flex-col sm:flex-row justify-between items-center animate-fade-in-up">
            <div className="text-sm mb-4 sm:mb-0 sm:mr-4 text-center sm:text-left">
                <p>
                    We use cookies to ensure you get the best experience on our website.{" "}
                    By continuing to use this site, you agree to our usage of cookies.
                </p>
                <Link to="/cookie-policy" className="text-orange underline hover:text-deeporange text-xs">
                    Read our Cookie Policy
                </Link>
            </div>
            <div className="flex space-x-3">
                <button
                    onClick={handleAccept}
                    className="bg-green text-white px-6 py-2 rounded-md font-semibold hover:bg-darkgreen transition-colors shadow-md"
                >
                    Got it
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;